<template>
  <div class="student-list">
    <el-dialog title="维度列表" :visible.sync="dimensionTableShow" width="50%" :before-close="handleClose">
      <el-table :data="tableData" class="table" style="width: 100%; max-height: 500px; overflow-y: auto;">
        <el-table-column prop="courseName" label="科目" width="50">
        </el-table-column>
        <el-table-column prop="avgScore" label="平均分" :width="columnWidth">
        </el-table-column>
        <el-table-column prop="fullMarkRate" label="满分率" :width="columnWidth">
        </el-table-column>
        <el-table-column prop="overallPassRate" label="及格率" :width="columnWidth">
        </el-table-column>
        <el-table-column prop="overtopAverageRate" label="超均率" :width="columnWidth">
        </el-table-column>
        <el-table-column prop="standardDeviation" label="标准差" :width="descList.length ? columnWidth : ''">
        </el-table-column>
        <el-table-column v-for="(item, index) in descList" :key="index" :label="item.desc">
          <template slot-scope="{ row }">
            <!-- <span> {{ item.descRate || '无' }}</span> -->
            <span v-if="row.descList.find((dItem) => dItem.desc === item.desc)">
              {{
                row.descList &&
                row.descList.find((dItem) => dItem.desc === item.desc)
                  ?.descRate
              }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-hasPermi="'sc:classdimension:export'" type="success" class="derive-text"
        @click="derivedIndex">导出维度</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: ["dimensionTableShow", "tableData", "descList", "classExamInfo"],
  data() {
    return {
      columnWidth: 65, // 单格表格宽度
    };
  },
  methods: {
    handleClose() {
      this.$emit("update:dimensionTableShow", false);
    },
    // 导出指标
    derivedIndex() {
      if (!this.tableData || this.tableData.length == 0 || !this.tableData.some(item => item.descList.length != 0)) return this.$message.warning("暂无指标");
      window.open(`${baseURL}${this.$url.examDimensionDetailsExcelPC}?examInfoId=${this.classExamInfo.id}&classId=${this.classExamInfo.classId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dimensionTableDialog.scss";
</style>